import React, {
  createContext,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";

// @ts-ignore
import setQuery from "set-query-string";

import queryString from "query-string";

const defaultVisibility: Record<string, boolean> = {
  b: true,
  a: true,
  t: true,
  d: true,
  r: true,
  p: true,
  time: true,
  l: true,
  c: true,
  o: true,
  n: true,
  no: false,
  co: false,
  m: false,
};

const DisplaySettingsContext = createContext<
  | {
      editMode: boolean;
      setEditMode: React.Dispatch<React.SetStateAction<boolean>>;
      visibility: Record<string, boolean>;
      setVisibility: React.Dispatch<
        React.SetStateAction<Record<string, boolean>>
      >;
      maxRecordsToShow: number;
      setMaxRecordsToShow: React.Dispatch<React.SetStateAction<number>>;
      maxDivisionsToShow: number;
      setMaxDivisionsToShow: React.Dispatch<React.SetStateAction<number>>;
      marqueeSpeed: number;
      setMarqueeSpeed: React.Dispatch<React.SetStateAction<number>>;
      isTableSettingsModalOpen: boolean;
      setIsTableSettingsModalOpen: React.Dispatch<
        React.SetStateAction<boolean>
      >;
    }
  | undefined
>(undefined);

export const DisplaySettingsProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const [editMode, setEditMode] = useState(false);
  const [visibility, setVisibility] = useState(defaultVisibility);
  const [maxRecordsToShow, setMaxRecordsToShow] = useState(1);
  const [maxDivisionsToShow, setMaxDivisionsToShow] = useState(1);
  const [marqueeSpeed, setMarqueeSpeed] = useState(100);
  const [isTableSettingsModalOpen, setIsTableSettingsModalOpen] =
    useState(false);

  const hasInitialized = useRef(false);

  useEffect(() => {
    if (hasInitialized.current) {
      const encodedData = btoa(JSON.stringify(visibility));

      setQuery({
        v: encodedData,
        mr: maxRecordsToShow,
        md: maxDivisionsToShow,
        ms: marqueeSpeed,
      });
    }
  }, [marqueeSpeed, maxDivisionsToShow, maxRecordsToShow, visibility]);

  useEffect(() => {
    try {
      if (window.location.search) {
        const queryData = queryString.parse(window.location.search);
        const encodedData = queryData["v"];
        if (encodedData && typeof encodedData === "string") {
          const data = JSON.parse(atob(encodedData));
          setVisibility(data);
        }

        const maxRecords = queryData["mr"];
        if (maxRecords && typeof maxRecords === "string") {
          setMaxRecordsToShow(parseInt(maxRecords));
        }

        const maxDivisions = queryData["md"];
        if (maxDivisions && typeof maxDivisions === "string") {
          setMaxDivisionsToShow(parseInt(maxDivisions));
        }

        const marqueeSpeed = queryData["ms"];
        if (marqueeSpeed && typeof marqueeSpeed === "string") {
          setMarqueeSpeed(parseInt(marqueeSpeed));
        }
      }
    } catch (e) {
      console.log("Failed to parse visibility data", e);
    }

    hasInitialized.current = true;
  }, []);

  return (
    <DisplaySettingsContext.Provider
      value={{
        editMode,
        setEditMode,
        visibility,
        setVisibility,
        maxRecordsToShow,
        setMaxRecordsToShow,
        maxDivisionsToShow,
        setMaxDivisionsToShow,
        marqueeSpeed,
        setMarqueeSpeed,
        isTableSettingsModalOpen,
        setIsTableSettingsModalOpen,
      }}
    >
      {children}
    </DisplaySettingsContext.Provider>
  );
};

export const useDisplaySettings = () => {
  const context = useContext(DisplaySettingsContext);
  if (!context) {
    throw new Error(
      "useDisplaySettings must be used within a DisplaySettingsContext",
    );
  }
  return context;
};
